(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7326],{

/***/ 50103:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spare-price-list",
      function () {
        return __webpack_require__(75091);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bg": function() { return /* binding */ Areas; },
/* harmony export */   "Le": function() { return /* binding */ locationFilterListService; },
/* harmony export */   "Z3": function() { return /* binding */ cityFilterList; },
/* harmony export */   "_D": function() { return /* binding */ locationFilterListShowRooms; },
/* harmony export */   "kB": function() { return /* binding */ isInHesderFilterList; },
/* harmony export */   "s0": function() { return /* binding */ ToggleButtons; }
/* harmony export */ });
var ToggleButtons;
(function(ToggleButtons) {
    ToggleButtons[ToggleButtons["CLOSE_TO_ME"] = 0] = "CLOSE_TO_ME";
    ToggleButtons[ToggleButtons["AREAS"] = 1] = "AREAS";
})(ToggleButtons || (ToggleButtons = {}));
var Areas;
(function(Areas) {
    Areas[Areas["ALL"] = 0] = "ALL";
    Areas[Areas["NORTH"] = 1] = "NORTH";
    Areas[Areas["CENTER"] = 2] = "CENTER";
    Areas[Areas["SOUTH"] = 3] = "SOUTH";
})(Areas || (Areas = {}));
var locationFilterListShowRooms = function(itemList, selectedAreaId, toggleIndex) {
    if (toggleIndex === ToggleButtons.CLOSE_TO_ME) {
        return itemList;
    }
    if (selectedAreaId === Areas.ALL) {
        return itemList;
    }
    return itemList.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.areaId) === selectedAreaId;
    });
};
var locationFilterListService = function(itemList, selectedAreaId, toggleIndex) {
    if (toggleIndex === ToggleButtons.CLOSE_TO_ME) {
        return itemList;
    }
    if (selectedAreaId === Areas.ALL) {
        return itemList;
    }
    return itemList.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.areaId) === selectedAreaId;
    });
};
var cityFilterList = function(itemList, cityId) {
    if (cityId === "" || cityId === null) {
        return itemList;
    }
    return itemList.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.city) === cityId;
    });
};
var isInHesderFilterList = function(itemList, inHesder) {
    if (!inHesder) {
        return itemList;
    }
    return itemList.filter(function(item) {
        return item === null || item === void 0 ? void 0 : item.isInHesder;
    });
};


/***/ }),

/***/ 70498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var common_bit_SingleButtonSelection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74962);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: 320px;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  flex-direction: row;\n  width: 100%;\n  gap: 0px;\n  background-color: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 3px;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  :focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 0px;\n  background-color: ",
        ";\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TwoToggleButtons__StyledWrapper",
    componentId: "sc-a9947446-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSingleButtonSelection = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(common_bit_SingleButtonSelection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "TwoToggleButtons__StyledSingleButtonSelection",
    componentId: "sc-a9947446-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.saphire;
}, function(p) {
    return p.theme.colors.saphire;
});
var StyledButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "TwoToggleButtons__StyledButton",
    componentId: "sc-a9947446-2"
})(_templateObject2());
var StyleCardButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TwoToggleButtons__StyleCardButton",
    componentId: "sc-a9947446-3"
})(_templateObject3(), function(p) {
    return p.$activeButton ? p.theme.colors.saphire : p.theme.colors.white;
}, function(p) {
    return p.$activeButton ? p.theme.colors.white : p.theme.colors.saphire;
});
var TwoToggleButtons = function(param) {
    var activeButton = param.activeButton, setActiveButton = param.setActiveButton, optionsList = param.optionsList, toggleId = param.toggleId, className = param.className, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSingleButtonSelection, {
            id: toggleId,
            items: optionsList.map(function(item, index) {
                return {
                    value: index,
                    name: item
                };
            }),
            itemsPerRow: 2,
            selectedValue: activeButton,
            onSelect: function(code) {
                setActiveButton(Number(code));
                if (onSelect) {
                    onSelect === null || onSelect === void 0 ? void 0 : onSelect();
                }
            },
            customButton: function(radioId, isSelected, item) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                    htmlFor: radioId,
                    $activeButton: isSelected,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyleCardButton, {
                        $activeButton: isSelected,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .TypographyRtl */ .UE, {
                            variant: "body2",
                            children: item.name
                        })
                    })
                });
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TwoToggleButtons);


/***/ }),

/***/ 75091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ spare_price_list; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(56847);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Table/Table.js
var Table = __webpack_require__(82302);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableHead/TableHead.js
var TableHead = __webpack_require__(83750);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow = __webpack_require__(57394);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell = __webpack_require__(88222);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableBody/TableBody.js
var TableBody = __webpack_require__(99613);
// EXTERNAL MODULE: ./api/delek.ts
var delek = __webpack_require__(55417);
// EXTERNAL MODULE: ./common/BreadCrumbs.tsx + 2 modules
var BreadCrumbs = __webpack_require__(15738);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/form/FormikForm.tsx
var FormikForm = __webpack_require__(95055);
// EXTERNAL MODULE: ./common/bit/form/FormikInput.tsx
var FormikInput = __webpack_require__(11852);
// EXTERNAL MODULE: ./common/bit/form/FormikSchema.ts
var FormikSchema = __webpack_require__(46363);
// EXTERNAL MODULE: ./components/mapPages/map/utils/mapFilters.ts
var mapFilters = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/TwoToggleButtons.tsx
var TwoToggleButtons = __webpack_require__(70498);
// EXTERNAL MODULE: ./reusable/wrappers/BodyText.tsx
var BodyText = __webpack_require__(97294);
// EXTERNAL MODULE: ./reusable/wrappers/ImageContainer.tsx
var ImageContainer = __webpack_require__(63358);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./common/bit/utils/formatters.ts
function formatNumber(value) {
    var maximumFractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var num = typeof value == "string" ? parseFloat(value) : value;
    return isNaN(num) ? value.toString() : Intl.NumberFormat("he-IL", {
        maximumFractionDigits: maximumFractionDigits
    }).format(num);
}
var formatPhone = function(number) {
    return number.replace(/^(\d{2,3})(\d{7})$/, "$1-$2");
};
function formatCurrency(value) {
    var maximumFractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Intl.NumberFormat("he-IL", {
        maximumFractionDigits: maximumFractionDigits
    }).format(value);
}
var startsWithHebrewRegex = /^[\u0590-\u05fe]/;
function getDirection(unit) {
    return startsWithHebrewRegex.test(unit) ? "rtl" : "ltr";
}
var trimPersonalId = function(number) {
    return number === null || number === void 0 ? void 0 : number.replace(/^0+/, "");
};

;// CONCATENATED MODULE: ./reusable/icons/PriceListVectorIcon.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "19",
        height: "14",
        viewBox: "0 0 19 14",
        fill: "none",
        role: "image",
        "aria-label": "exists",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M18.0938 1.53125L7.15625 12.4688L1.6875 7",
            stroke: "#910A2D",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var PriceListVectorIcon = (SvgComponent);

;// CONCATENATED MODULE: ./components/pages/SparePriceListData.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: auto;\n  transform: rotateX(180deg);\n  margin-top: 40px;\n  &::-webkit-scrollbar {\n    height: 4px;\n    background-color: transparant;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: rotateX(180deg);\n  .bold {\n    font-weight: bold;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n  text-align: center;\n  padding: 25px 17px;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  color: ",
        ";\n  text-align: center;\n  padding: 25px 17px;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-right: 3px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    padding: 0px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var TableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SparePriceListData__TableWrapper",
    componentId: "sc-1d896926-0"
})(_templateObject(), function(p) {
    return p.theme.colors.notExistentSaphire;
});
var StyledTable = (0,styled_components_browser_esm/* default */.ZP)(Table/* default */.Z).withConfig({
    displayName: "SparePriceListData__StyledTable",
    componentId: "sc-1d896926-1"
})(_templateObject1());
var StyledTableHead = (0,styled_components_browser_esm/* default */.ZP)(TableHead/* default */.Z).withConfig({
    displayName: "SparePriceListData__StyledTableHead",
    componentId: "sc-1d896926-2"
})(_templateObject2());
var StyledTableRow = (0,styled_components_browser_esm/* default */.ZP)(TableRow/* default */.Z).withConfig({
    displayName: "SparePriceListData__StyledTableRow",
    componentId: "sc-1d896926-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.darkGrey;
});
var StyledHeadCell = (0,styled_components_browser_esm/* default */.ZP)(TableCell/* default */.Z).withConfig({
    displayName: "SparePriceListData__StyledHeadCell",
    componentId: "sc-1d896926-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledCell = (0,styled_components_browser_esm/* default */.ZP)(TableCell/* default */.Z).withConfig({
    displayName: "SparePriceListData__StyledCell",
    componentId: "sc-1d896926-5"
})(_templateObject5(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledCurrency = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SparePriceListData__StyledCurrency",
    componentId: "sc-1d896926-6"
})(_templateObject6(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SparePriceListData__StyledPrice",
    componentId: "sc-1d896926-7"
})(_templateObject7(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    displayName: "SparePriceListData__StyledContainer",
    componentId: "sc-1d896926-8"
})(_templateObject8(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var SparePriceListData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTable, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHead, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTableRow, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadCell, {
                                        children: "ספק"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadCell, {
                                        children: "מק״ט פריט"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadCell, {
                                        children: "תיאור"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadCell, {
                                        children: "תיאור באנגלית"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadCell, {
                                        children: "תיאור דגם"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadCell, {
                                        children: "מקורי"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadCell, {
                                        children: 'מק"ט ספק'
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadCell, {
                                        children: "קוד דגם"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadCell, {
                                        children: "מלאי"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadCell, {
                                        children: "מחיר מרבי מומלץ"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                            children: data.slice(0, 50).map(function(replacement, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTableRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                            children: replacement.provider
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                            children: replacement.item
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                            children: replacement.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                            children: replacement.foreignName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                            children: replacement.modelDescription
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                            children: replacement.isOriginal === "מקורי" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceListVectorIcon, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                            children: replacement.sku
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                            children: replacement.vehicleModel
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                            children: replacement.isWithQuantity
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCell, {
                                            className: "bold",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCurrency, {
                                                    children: " ₪"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrice, {
                                                    children: formatCurrency(replacement.priceWithTax, 2)
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var pages_SparePriceListData = (SparePriceListData);

;// CONCATENATED MODULE: ./components/pages/SparePriceListPage.tsx



function SparePriceListPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  background: ",
        ";\n  padding-bottom: 80px;\n  .MuiOutlinedInput-root {\n    width: 320px;\n    ",
        " {\n      width: 100%;\n    }\n  }\n"
    ]);
    SparePriceListPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SparePriceListPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: 40px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  ",
        " {\n    text-align: right;\n    align-items: flex-start;\n  }\n"
    ]);
    SparePriceListPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SparePriceListPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 50px;\n  ",
        " {\n    margin-top: 20px;\n    width: 100%;\n  }\n"
    ]);
    SparePriceListPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SparePriceListPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    max-width: 320px;\n  }\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    SparePriceListPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SparePriceListPage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px 0px;\n"
    ]);
    SparePriceListPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SparePriceListPage_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 18px;\n  text-decoration: underline;\n  margin-top: 40px;\n  ",
        " {\n    margin-bottom: 40px;\n  }\n"
    ]);
    SparePriceListPage_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SparePriceListPage_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  height: 1px;\n  width: 100%;\n"
    ]);
    SparePriceListPage_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SparePriceListPage_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SparePriceListPage_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SparePriceListPage_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  ",
        " {\n    margin-top: 0px;\n  }\n  li {\n    font-size: 18px;\n    weight: 400;\n  }\n"
    ]);
    SparePriceListPage_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n  position: absolute;\n  width: 320px;\n  bottom: -15px;\n  right: 0;\n  margin-top: 10px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-top: 25px;\n  fieldset {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


















var StyledPageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SparePriceListPage__StyledPageDiv",
    componentId: "sc-b59c900b-0"
})(SparePriceListPage_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTopWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SparePriceListPage__StyledTopWrapper",
    componentId: "sc-b59c900b-1"
})(SparePriceListPage_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledToggleButtons = (0,styled_components_browser_esm/* default */.ZP)(TwoToggleButtons/* default */.Z).withConfig({
    displayName: "SparePriceListPage__StyledToggleButtons",
    componentId: "sc-b59c900b-2"
})(SparePriceListPage_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SparePriceListPage__StyledWrap",
    componentId: "sc-b59c900b-3"
})(SparePriceListPage_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "SparePriceListPage__StyledButton",
    componentId: "sc-b59c900b-4"
})(SparePriceListPage_templateObject4());
var StyledLinkWrapp = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "SparePriceListPage__StyledLinkWrapp",
    componentId: "sc-b59c900b-5"
})(SparePriceListPage_templateObject5(), function(p) {
    return p.theme.colors.saphire;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SparePriceListPage__StyledLine",
    componentId: "sc-b59c900b-6"
})(SparePriceListPage_templateObject6(), function(p) {
    return p.theme.colors.darkGrey;
});
var SparePriceListPage_StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    displayName: "SparePriceListPage__StyledContainer",
    componentId: "sc-b59c900b-7"
})(SparePriceListPage_templateObject7());
var StyledBodyWrapp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SparePriceListPage__StyledBodyWrapp",
    componentId: "sc-b59c900b-8"
})(SparePriceListPage_templateObject8(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "caption"
}).withConfig({
    displayName: "SparePriceListPage__StyledError",
    componentId: "sc-b59c900b-9"
})(_templateObject9(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SparePriceListPage__StyledFormWrapper",
    componentId: "sc-b59c900b-10"
})(_templateObject10(), function(p) {
    return p.$error && "#b50303 !important";
});
var schemaDescription = es/* object */.Ry({
    description: FormikSchema/* schemaCommon.catalog */.Cr.catalog
}).defined();
var schemaCatalog = es/* object */.Ry({
    catalogNumber: FormikSchema/* schemaCommon.catalog */.Cr.catalog
}).defined();
var SparePriceListPage = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref = (0,react.useState)(mapFilters/* ToggleButtons.CLOSE_TO_ME */.s0.CLOSE_TO_ME), toggleIndex = ref[0], setToggleIndex = ref[1];
    var catalogValue = {
        catalogNumber: "",
        description: ""
    };
    var ref1 = (0,react.useState)(null), response = ref1[0], setResponse = ref1[1];
    var ref2 = (0,react.useState)(null), skuError = ref2[0], setSkuError = ref2[1];
    var ref3 = (0,react.useState)(null), nameError = ref3[0], setNameError = ref3[1];
    var ref4 = (0,react.useState)(false), openTable = ref4[0], setOpenTable = ref4[1];
    var error = "אנא בדוק שהזנת את הפרטים הנכונים ונסה שוב.  במידה ועדיין לא מצאת את מה שאתה מחפש הנך מוזמן ליצור קשר עם מוקד השירות.";
    var date = new Date();
    var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    var formattedDate = firstDayOfMonth.toLocaleDateString("he-IL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    }).replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$1.$2.$3");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledPageWrapper */.S0, {
        $padding: "0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer/* default */.Z, {
                    src: isDesktop ? "/img/spareprice.jpg" : "/img/sparepricemobile.jpg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    name: "SparePriceList"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SparePriceListPage_StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* TypographyRtl */.UE, {
                                    variant: "h1",
                                    $fontSize: "24px",
                                    $fontWeight: "400",
                                    children: [
                                        "מחירון מוצרי תעבורה (חלפים)",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                                    $margin: 20,
                                    children: "לחיפוש, יש להקליד כאן את המספר הקטלוגי או את שם חלק מתיאור הפריט"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledToggleButtons, {
                                    activeButton: toggleIndex,
                                    setActiveButton: setToggleIndex,
                                    optionsList: [
                                        "מס׳ קטלוגי",
                                        "שם פריט"
                                    ],
                                    toggleId: "map-toggle"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
                                    validationSchema: toggleIndex === 0 ? schemaCatalog : schemaDescription,
                                    initialValues: catalogValue,
                                    onSubmit: function() {
                                        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                                            var data;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            (0,delek/* GetPriceListReplacements */.C4)(toggleIndex === 0 ? values.catalogNumber : values.description, toggleIndex === 0 ? "sku" : "name")
                                                        ];
                                                    case 1:
                                                        data = _state.sent().data;
                                                        setResponse(data);
                                                        if (data.data.length === 0) {
                                                            toggleIndex === 0 ? setSkuError(error) : setNameError(error);
                                                        } else {
                                                            setSkuError(null);
                                                            setNameError(null);
                                                        }
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(values) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    render: function(formik) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormWrapper, {
                                                    $error: skuError && toggleIndex === 0 || nameError && toggleIndex === 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                                                            name: "".concat(toggleIndex === 0 ? "catalogNumber" : "description"),
                                                            label: toggleIndex === 0 ? "L3C115909 :מק״ט, לדוגמה" : "שם פריט, לדוגמה: מסנן שמן",
                                                            onChange: function(e) {
                                                                var btnType = toggleIndex === 0 ? "catalogNumber" : "description";
                                                                formik.setFieldValue(btnType, e.target.value);
                                                                if (btnType === "catalogNumber" && skuError && e.target.value.length === 0) {
                                                                    setSkuError(null);
                                                                }
                                                                if (btnType === "description" && nameError && e.target.value.length === 0) {
                                                                    setNameError(null);
                                                                }
                                                            }
                                                        }),
                                                        skuError && toggleIndex === 0 && formik.values.catalogNumber.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledError, {
                                                            id: "catalogNumber-helper-text",
                                                            children: skuError
                                                        }),
                                                        nameError && toggleIndex === 1 && formik.values.description.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledError, {
                                                            id: "description-helper-text",
                                                            children: nameError
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrap, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                                        disabled: formik.isSubmitting,
                                                        fullWidth: true,
                                                        variant: "text",
                                                        type: "submit",
                                                        children: "לחיפוש"
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                }),
                                (response === null || response === void 0 ? void 0 : response.data) && response.data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_SparePriceListData, {
                                    data: response.data
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkWrapp, {
                                    href: "/services-centers",
                                    children: "לרשימת מרכזי שירות מורשים"
                                }),
                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLine, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBodyWrapp, {
                            children: [
                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                                            children: "מוקד שירות לקוחות"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledLink */.Fg, {
                                            href: "tel:*2880",
                                            $color: "#4C607E",
                                            style: {
                                                unicodeBidi: "plaintext"
                                            },
                                            children: [
                                                " ",
                                                "*2880"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledUl */.hc, {
                                    $padding: 25,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                            $margin: 20,
                                            children: 'המחיר לעיל כולל מע"מ.'
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                            $margin: 5,
                                            children: "המחירים אינם כוללים את עבודת הפירוק וההתקנה ברכב"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledLi */.EF, {
                                            $margin: 5,
                                            children: [
                                                "הנתונים המוצגים במנגנון זה נכונים לתאריך ",
                                                formattedDate
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                            $margin: 5,
                                            children: "דלק מוטורס רשאית לשנות את מחירי החלפים בכל עת וללא הודעה מוקדמת"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                            $margin: 5,
                                            children: "אנו פועלים לעדכון שוטף של המחירים במנגנון זה אולם יתכנו הבדלים בין המחירים המופיעים בו לבין מחירי החלפים בפועל"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                            $margin: 5,
                                            children: 'אחריות לחלפים מקוריים: האחריות לחלק תינתן למשך 12 חודשים ללא הגבלת ק"מ ממועד התקנתו ברכב'
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                            $margin: 5,
                                            children: "האחריות הינה לחלק בלבד והיא לא תכסה את העבודה ו/או פגם שנוצר עקב התקנה לקויה ו/או שימוש בלתי סביר ברכב"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledLi */.EF, {
                                            $margin: 5,
                                            children: [
                                                'אחריות לחלפים שאינם מקוריים: האחריות לחלק שאינו מקורי תינתן למשך 3 חודשים או 6000 ק"מ ממועד התקנתם ברכב, המוקדם מבניהם, למעט חלפים המפורטים ברשימה המצורפת',
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                                    href: "",
                                                    $color: "#4C607E",
                                                    onClick: function(e) {
                                                        e === null || e === void 0 ? void 0 : e.preventDefault();
                                                        setOpenTable(function(isOpen) {
                                                            return !isOpen;
                                                        });
                                                    },
                                                    children: "לחץ כאן"
                                                }),
                                                openTable && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                                                    component: Paper/* default */.Z,
                                                    style: {
                                                        margin: "16px 0"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                                            children: "סוג הפריט"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                                            children: "האחריות הניתנת לגביו"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                                                children: "מצברים לא מקוריים"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                                                children: 'אחריות בהתאם לזו המסופקת ע"י יצרן המצברים (12 חודשים או 20 חודשים בהתאם לסוג המצבר שנרכש).'
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                                                children: "תיבות הילוכים משופצות"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                                                children: 'אחריות של 12 חודשים או 20,000 ק"מ המוקדם שבהם'
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                            $margin: 5,
                                            children: 'לדגמי רכב רבים קיימים תתי דגמים ולעיתים נדרשות בקיאות והתמצאות באיתור המק"ט של החלק המתאים לדגם הרכב הרצוי. אנו ממליצים להיכנס למרכז שירות מורשה מטעם דלק מוטורס לזיהוי'
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                            $margin: 5,
                                            children: 'דלק מוטורס בע"מ ת.ד. 200 מושב ניר צבי 72905'
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledLi */.EF, {
                                            $margin: 5,
                                            children: [
                                                'לרכישת המחירון כקובץ אקסל ניתן לפנות אל דלק מוטורס בע"מ באמצעות דואר אלקטרוני',
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                                    $color: "#4C607E",
                                                    href: "mailto: service1@delekmotors.co.il",
                                                    children: "service1@delekmotors.co.il"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                                            $margin: 40,
                                            children: "מוקד שירות לקוחות"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledLink */.Fg, {
                                            href: "tel:*2880",
                                            $color: "#4C607E",
                                            style: {
                                                unicodeBidi: "plaintext"
                                            },
                                            children: [
                                                " ",
                                                "*2880"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var pages_SparePriceListPage = (SparePriceListPage);

;// CONCATENATED MODULE: ./src/pages/spare-price-list.tsx



var SparePriceList = function(param) {
    var seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_SparePriceListPage, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var spare_price_list = (SparePriceList);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4245,2669,6808,6104,9774,2888,179], function() { return __webpack_exec__(50103); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);